export default __webpack_public_path__ + "static/media/offPremium_logo.48feafd4.svg";